/**
 * Menu-related translations for Chinese (Traditional) language
 * This file contains translations for navigation and menu items
 */
export default {
  menu: {
    menu: '選單',
    home: '主頁',
    profile: '設定',
    wiki: '維基',
    about: '關於',
    stats: '統計',
  },
};
